module.exports = __webpack_public_path__ + "static/media/om_eyeshape_almond_darkbrown.50f68e5f.png";